import React, { useMemo } from 'react'
import { FormattedMessage as ReactFormattedMessage } from 'react-intl'
import User from 'components/ControlledUser'
import ActivityUser from 'components/ActivityGroup/ActivityUser'
import { convertFromToUser } from 'utils/users'
import BoardName from 'components/BoardName'
import LabelName from 'components/LabelName'
import KanBoIcon from 'components/KanBoIcon'

type Props = React.ComponentProps<typeof ReactFormattedMessage> & {
  values?: any;
}

const FormattedMessage: React.FC<Props> = ({
  values,
  ...props
}) => {
  const memoValues = useMemo(() => {
    if (typeof values === 'object') {
      return Object.keys(values).reduce((prevValue, key) => {
        prevValue[key] = (() => {
          const value = values[key]

          if (typeof value === 'object' && value.type) {
            switch (value.type) {
              case 'user':
                return <User text id={value.id} />
              case 'from':
                return <ActivityUser text fromUser={convertFromToUser(value.id)} />
              case 'board':
                return (
                  <BoardName id={value.id}>
                    {({ name }) => name || <KanBoIcon spin name='kanbo-16-loading' />}
                  </BoardName>
                )
              case 'label':
                return (
                  <LabelName id={value.id}>
                    {({ name }) => name || <KanBoIcon spin name='kanbo-16-loading' />}
                  </LabelName>
                )
              default:
                return JSON.stringify(value)
            }
          }

          return value
        })()
  
        return prevValue
      }, {})
    }

    return values
  }, [values])

  return (
    <ReactFormattedMessage
      {...props}
      values={memoValues}
    />
  )
}

export default FormattedMessage
